/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

export const prompts = {
  PROMPT_LOADING: 'PROMPT_LOADING',
  PROMPT_BY_TRACE_ID_LOADING: 'PROMPT_BY_TRACE_ID_LOADING',
  FETCH_PROMPTS: 'FETCH_PROMPTS',
  FETCH_PROMPTS_BY_TRACE_ID: 'FETCH_PROMPTS_BY_TRACE_ID',
  FETCH_PROMPTS_SEQUENCE: 'FETCH_PROMPTS_SEQUENCE',
  FETCH_PROMPTS_SEQUENCE_BY_TRACE_ID: 'FETCH_PROMPTS_SEQUENCE_BY_TRACE_ID',
  PROMPT_ERROR: 'PROMPT_ERROR',
  PROMPT_QUERY_PARAMS: 'PROMPT_QUERY_PARAMS',
  CLEAR_PROMPTS: 'CLEAR_PROMPTS',
  FETCH_SANKEY_METADATA: 'FETCH_SANKEY_METADATA',
  SET_FACT_NAME: 'SET_FACT_NAME',
  SET_FACTS_DATA: 'SET_FACTS_DATA',
};

export const traces = {
  SET_RAW_BREAKDOWNS: 'SET_RAW_BREAKDOWNS',
  FETCH_BREAKDOWNS: 'FETCH_BREAKDOWNS',
  FETCH_BREAKDOWNS_LOADING: 'FETCH_BREAKDOWNS_LOADING',
  FETCH_FACTS: 'FETCH_FACTS',
  IS_REFRESHING: 'IS_REFRESHING',
  SET_FACT_NAME: 'SET_FACT_NAME',
  TRACES_LOADING: 'TRACES_LOADING',
  TRACE_SPAN_LOADING: 'TRACE_SPAN_LOADING',
  SPAN_PAGINATION_LOADING: 'SPAN_PAGINATION_LOADING',
  FETCH_TRACES: 'FETCH_TRACES',
  FETCH_TRACES_BY_ID: 'FETCH_TRACES_BY_ID',
  TRACES_ERROR: 'TRACES_ERROR',
  FETCH_TRACE_SPAN_ERROR: 'FETCH_TRACE_SPAN_ERROR',
  TRACES_QUERY_PARAMS: 'TRACES_QUERY_PARAMS',
  FETCH_TRACE_SPAN_DETAILS: 'FETCH_TRACE_SPAN_DETAILS',
  FETCH_HISTOGRAM_DATA: 'FETCH_HISTOGRAM_DATA',
  HISTOGRAM_DATA_LOADING: 'HISTOGRAM_DATA_LOADING',
  SET_GENERAL_LOADING: 'SET_GENERAL_LOADING',
  CLEAR_TRACES: 'CLEAR_TRACES',
  CLEAR_HISTOGRAM: 'CLEAR_HISTOGRAM',
  SET_ERROR_CATEGORIES: 'SET_ERROR_CATEGORIES',
  SET_ERROR_CATEGORIES_LOADING: 'SET_ERROR_CATEGORIES_LOADING',
  SET_VIEW_BY: 'SET_VIEW_BY',
  SET_SELECTED_ERROR_CATEGORY: 'SET_SELECTED_ERROR_CATEGORY',
  SET_SELECTED_TRACE_IN_ERROR_CATEGORY: 'SET_SELECTED_TRACE_IN_ERROR_CATEGORY',
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  FETCH_FACT_COUNT: 'FETCH_FACT_COUNT',
  FETCH_FACT_MEASURES: 'FETCH_FACT_MEASURES',
  FACT_MEASURES_LOADING: 'FACT_MEASURES_LOADING',
  FETCH_TRACE_TOKEN_MEASURES: 'FETCH_TRACE_TOKEN_MEASURES',
  TRACE_TOKEN_MEASURES_LOADING: 'TRACE_TOKEN_MEASURES_LOADING',
  FETCH_FACT_IDS: 'FETCH_FACT_IDS',
  FETCH_FACT_IDS_MAP: 'FETCH_FACT_IDS_MAP',
  STAGE_PENDING_FACT_IDS: 'STAGE_PENDING_FACT_IDS',
  COMMIT_PENDING_FACT_IDS: 'COMMIT_PENDING_FACT_IDS',
  SET_FACT_IDS_NEXT_PAGE_TOKEN: 'SET_FACT_IDS_NEXT_PAGE_TOKEN',
  SET_FACT_IDS_COUNT: 'SET_FACT_IDS_COUNT',
  FACT_IDS_LOADING_MORE: 'FACT_IDS_LOADING_MORE',
  FETCH_MORE_TRACES: 'FETCH_MORE_TRACES',
  TRACES_LOADING_MORE: 'TRACES_LOADING_MORE',
};

export const FACT_IDS_PREFETCH_THRESHOLD = 3;

// Fact types whose grouped trace lists are server-paginated (via next_page_token)
// and shown a page at a time in the tree view. Add new fact keys here to opt them in.
export const PAGINATED_FACT_NAMES = [
  'test_runs',
  'git_commits',
  'agent_sessions',
];

// Page size for a paginated fact's traces. Drives BOTH the backend fetch batch
// (page_size / next_page_token) and the number of traces shown per page in the
// tree view, so one fetch == one page. Lower it to exercise the next_page_token
// fetch-more path against facts with few traces. Production value: 20.
export const TRACE_FETCH_PAGE_SIZE = 10;

// The top-level traces list is cursor-paginated independently from grouped
// fact traces. Fetch a larger batch so users can navigate 100 traces before
// another continuation request is needed.
export const PLAIN_TRACES_FETCH_PAGE_SIZE = 100;

export const KahuPredefinedPrompts = [
  'What applications are available?',
  'Show me error traces in the last hour',
  'Find prompts with negative sentiment',
  'What errors occurred today?',
];

export const traceID = {
  FETCH_TRACES_BY_ID: 'FETCH_TRACES_BY_ID',
  TRACE_ID_ERROR: 'TRACE_ID_ERROR',
  TRACE_ID_LOADING: 'TRACE_ID_LOADING',
  CLEAR_TRACE_ID_RESULTS: 'CLEAR_TRACE_ID_RESULTS',
  TRACE_ID_LOADING_MORE: 'TRACE_ID_LOADING_MORE',
  FETCH_MORE_TRACES_BY_ID: 'FETCH_MORE_TRACES_BY_ID',
  SET_TRACE_ID_PAGE_META: 'SET_TRACE_ID_PAGE_META',
};

export const CONVERSATION_COUNT_IN_ONE_TAB = 20;
export const DEFAULT_BREAKDOWN_VALUES = {
  all: 'traces',
  performance: 'traces.genai.completed',
  reliability: 'traces.genai.error.in_root',
};

export const DEFAULT_BREAKDOWN_VALUE_FOR_RELIABILITY =
  DEFAULT_BREAKDOWN_VALUES.reliability;

export const MILLISECONDS_IN_A_DAY = 24 * 60 * 60 * 1000;
export const MAX_FACT_IDS = 50;

export const EVALS_API_ERROR_KEY = 'eval-api-errors';

export const KAHU_AI_LINKS = [
  {
    href: 'https://docs.okahu.ai/get_started_okahu_cloud/#explore-okahu-cloud-with-a-demo-app',
    text: 'Explore demo apps',
  },
  {
    href: 'https://docs.okahu.ai/get_started_okahu_cloud/#find-issues-with-your-app-using-pre-built-insights',
    text: 'Get insights on your app',
  },
];
